<template>
  <template v-for="(image, index) in props.images" :key="image.id">
    <DatoCmsImage
      :data="image.responsiveImage"
      object-fit="cover"
      :object-position="`${image.focalPoint.x * 100}% ${
        image.focalPoint.y * 100
      }%`"
      layout="fill"
      :class="bem({isActive: index === activeIndex})"
    />
  </template>
</template>
<script setup lang="ts">
import { Image as DatoCmsImage } from 'vue-datocms'
const bem = useBEM('ImageReel')
interface MediaItemProps {
  images: any[]
  speed?: number
}

const props = withDefaults(defineProps<MediaItemProps>(), {
  speed: 500,
})

const activeIndex = ref(0);
let intervalId: ReturnType<typeof setInterval> | null = null;

const nextIndex = () => {
  activeIndex.value = (activeIndex.value + 1) % props.images.length;
};

onMounted(() => {
  if (props.images.length > 1 && props.speed > 0) {
    intervalId = setInterval(nextIndex, props.speed);
  }
});
onUnmounted(() => {
  if (intervalId) {
    clearInterval(intervalId);
  }
});
</script>

<style lang="postcss">
.ImageReel {
  @apply opacity-0;
  &--is-active {
    @apply opacity-100;
  }
}
</style>